import { render, staticRenderFns } from "./NovoUsuario.vue?vue&type=template&id=c49e95d6"
import script from "./NovoUsuario.vue?vue&type=script&lang=js"
export * from "./NovoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports